"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Fieldset = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const styled_components_1 = __importDefault(require("styled-components"));
const framer_motion_1 = require("framer-motion");
const styles_1 = require("../styles");
const Fieldset = ({ col = 12, children, disabled = false, ariaBusy = false, legend }) => {
    return ((0, jsx_runtime_1.jsxs)(FieldsetStyled, Object.assign({ col: col, disabled: disabled, "aria-busy": ariaBusy, variants: variants, initial: 'initial', animate: 'active', exit: 'exit' }, { children: [legend && (0, jsx_runtime_1.jsx)("legend", { children: legend }), (0, jsx_runtime_1.jsx)("div", Object.assign({ className: 'fieldset-content-wrapper' }, { children: children }))] })));
};
exports.Fieldset = Fieldset;
const FieldsetStyled = (0, styled_components_1.default)(framer_motion_1.motion.fieldset) `
  width: 100%;

  ${styles_1.mq.greaterThan('tablet')} {
    width: ${({ col }) => 100 * col / 12}%;
  }

  &[disabled] {
    opacity: .5;
  }

  &[aria-busy='true'] {
    opacity: .6;
  }

  legend,
  .light {
    ${styles_1.getP20v2}
    font-family: ${({ theme }) => theme.fonts.tertiaryFont};
    margin-bottom: ${(0, styles_1.vw)(20, 'mobile')};
    padding: 0 ${(0, styles_1.vw)(4.25, 'mobile')};
    width: 100%;

    ${styles_1.mq.greaterThan('nexus7')} {
      margin-bottom: ${(0, styles_1.vw)(20, 'nexus7')};
      padding: 0 ${(0, styles_1.vw)(4.5, 'nexus7')};
    }

    ${styles_1.mq.greaterThan('tablet')} {
      margin-bottom: ${(0, styles_1.vw)(20, 'desktop')};
      padding: 0 ${(0, styles_1.vw)(12.5, 'desktop')};
    }

    ${styles_1.mq.greaterThan('desktop')} {
      margin-bottom: 20px;
      padding: 0 12.5px;
    }

    a,
    button {
      color: inherit;
      font-size: inherit;
      font-weight: inherit;
      line-height: inherit;
      text-decoration: underline;
      transition: 300ms opacity ease-out;

      &:hover {
        opacity: .8;
      }
    }
  }

  .p-subinput,
  .p-tiny {
    ${(0, styles_1.getP12_1)()}
    color: ${({ theme }) => theme.colors.darkred};
    font-weight: normal;
    padding: 0 ${(0, styles_1.vw)(4.25, 'mobile')};

    ${styles_1.mq.greaterThan('nexus7')} {
      padding: 0 ${(0, styles_1.vw)(4.25, 'nexus7')};
    }

    ${styles_1.mq.greaterThan('tablet')} {
      padding: 0 ${(0, styles_1.vw)(12.5, 'desktop')};
    }

    ${styles_1.mq.greaterThan('desktop')} {
      padding: 0 12.5px;
    }

    > a,
    > button {
      color: inherit
    }
  }

  .p-subinput {
    transform: translateY(-${(0, styles_1.vw)(20, 'mobile')});

    ${styles_1.mq.greaterThan('nexus7')} {
      transform: translateY(-${(0, styles_1.vw)(30, 'nexus7')});
    }

    ${styles_1.mq.greaterThan('tablet')} {
      transform: translateY(-${(0, styles_1.vw)(25, 'desktop')});
    }

    ${styles_1.mq.greaterThan('desktop')} {
      transform: translateY(-25px);
    }
  }

  legend {
    font-weight: 500;
  }

  .light {
    font-weight: 300;
  }

  .fieldset-content-wrapper {
    align-items: flex-start;
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-start;
    padding: 0 0 ${(0, styles_1.vw)(50, 'desktop')};
    width: 100%;

    ${styles_1.mq.greaterThan('nexus7')} {
      padding: 0 0 ${(0, styles_1.vw)(50, 'nexus7')};
    }

    ${styles_1.mq.greaterThan('tablet')} {
      padding: 0 0 ${(0, styles_1.vw)(50, 'desktop')};
    }

    ${styles_1.mq.greaterThan('desktop')} {
      padding: 0 0 50px;
    }
  }
`;
const variants = {
    'initial': {
        opacity: 0,
        height: 0,
        transition: {
            duration: .1,
        }
    },
    'active': {
        opacity: 1,
        height: 'auto',
        transition: {
            duration: .2,
        }
    },
    'exit': {
        opacity: 0,
        height: 0,
        transition: {
            duration: .1,
        }
    }
};
